import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import eventsAPI from "../api/eventsAPI";

const App = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const { login, setUser } = useAuth();

  const navigate = useNavigate();

  // Handles the form submission of the login form.
  // If the server returns a successful response, it logs the user in and navigates to the home page.
  // If the server returns an error, it shows an error message and sets the error state.
  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const response = await eventsAPI.post("/login", {
        email,
        password,
      });

      const { exists, login: isLoginSuccessful, user } = response.data;

      if (exists && isLoginSuccessful) {
        toast.success("Login successful");
        // Add email to setUser
        login(user);
        setUser((prevUser) => ({ ...prevUser, email }));
        navigate("/");
      } else if (exists && !isLoginSuccessful) {
        toast.error("Incorrect Credentials");
        setError("Invalid email or password.");
      } else {
        toast.error("User does not exist.");
        setError("User does not exist.");
      }
    } catch (error) {
      console.log(error);
      setError("Server is not Online. Please try again.");
    }
  };

  return (
    <div className="login-page">
      <div className="heading-section">
        <h1>SIGN IN PAGE</h1>
      </div>
      <main className="main">
        <div className="left-side"></div>
        <div className="right-side">
          <form onSubmit={handleSubmit}>
            <div className="btn-group">
              <button type="button" className="btn">
                <img
                  className="logo"
                  src="https://github.com/ecemgo/mini-samples-great-tricks/assets/13468728/d1c98974-c62d-4071-8bd2-ab859fc5f4e9"
                  alt=""
                />
                <span>Sign in with Google</span>
              </button>
              <button type="button" className="btn">
                <img className="logo" src="./facebook_icon.png" alt="" />
                <span>Sign in with Apple</span>
              </button>
            </div>
            <div className="or">OR</div>
            <label htmlFor="email">Email</label>
            <input
              type="text"
              placeholder="Enter Email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              //required
            />
            <label htmlFor="password">Password</label>
            <input
              type="password"
              placeholder="Enter Password"
              name="password"
              value={password}
              className="input"
              onChange={(e) => setPassword(e.target.value)}
              //required
            />
            {error && <div className="error">{error}</div>}
            <button type="submit" className="login-btn">
              Sign in
            </button>
            <div className="links">
              <Link to="/forgot-password">Forgot password?</Link>
              <Link to="/signup">Do not have an account?</Link>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default App;
